import { useCallback } from 'react'

import { VolunteerPreferredContactMethod } from 'civic-champs-shared/common/types'
import { useFetchRefactored } from 'civic-champs-shared/api/hooks'

const useSetContactMethod = () => {
  const [request] = useFetchRefactored()

  return useCallback(
    (personId: number, preferredContactMethod: VolunteerPreferredContactMethod) => {
      return request({
        method: 'put',
        url: `/people/${personId}/contact-method`,
        config: {
          body: {
            preferredContactMethod,
          },
        },
      })
    },
    [request],
  )
}

export default useSetContactMethod
